export const TOTP_CODE_LENGTH = 6;
export const RECOVERY_CODE_LENGTH = 11;

export const AUTHENTICATION_PATH = "/admin/settings/authentication";
export const ENROLLED_USERS_PATH = `${AUTHENTICATION_PATH}/2fa/enrolled`;
export const UNENROLLED_USERS_PATH = `${AUTHENTICATION_PATH}/2fa/unenrolled`;
